"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditorTypes_1 = require("../EditorTypes");
var BehaviourBuilder_1 = require("./BehaviourBuilder");
var PromptTypes_1 = require("Prompt/PromptTypes");
exports.default = (function (di) {
    return {
        keyDown: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("keyDown")
            .isEvent(EditorTypes_1.EventType.Key)
            .doAction(function (event, editor) {
            di.get("rootDataStore").userDataStore.useHistoryDataStore.clickedPrompt(PromptTypes_1.PromptId.EditText);
            return;
        }),
    };
});
